import React, { useContext } from "react";
import {
  Navbar,
  NavItem,
  NavbarToggler,
  Collapse,
  NavLink,
  Nav,
  NavbarBrand,
} from "reactstrap";
import "./NavbarComponent.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { PathContext } from "../../App";
function NavbarComponent() {
  const location = useLocation();
  const navigate = useNavigate();
  const { path, setPath } = useContext(PathContext);
  const [isOpen, setIsOpen] = React.useState(false);

  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const agentVendorType = localStorage.getItem("agentVendorType");
  const advertiserId = localStorage.getItem("advertiserId");
  const handleClick = () => {
    setPath("nav");
    navigate("/user-register");
  };
  const handleClick2 = () => {
    navigate("/agent-register");
  };
  const handleClick3 = () => {
    navigate("/advertiser-register");
  };
  const handleClick4 = () => {
    navigate("/tc-register");
  };

  return (
    <Navbar className="home-navbar" expand="lg">
      <NavbarBrand>
        <Link style={{ textDecoration: "none" }} to="/">
          <img src="/img/Logo.svg" className="home-logo" alt="" />
        </Link>
      </NavbarBrand>
      <NavbarToggler
        className="home-nav-toggler"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      />
      <Collapse isOpen={isOpen} navbar>
        <Nav className="ms-auto mobile-nav flex-wrap justify-content-end" navbar>
          <NavItem className="mobile-nav-item">
            <Link
              className={`home-nav-link ${location.pathname === "/" ? "home-nav-active" : ""}`}
              to="/"
            >
              Home
            </Link>
          </NavItem>

          <NavItem className="mobile-nav-item">
            <span
              role="button"
              className={`home-nav-link ${location.pathname === "/advertiser-register" ? "home-nav-active" : ""}`}
              onClick={handleClick3}
            >
              {advertiserId && token ? <>Dashboard</> : <>Service Provider</>}
            </span>
          </NavItem>
          <NavItem className="mobile-nav-item">
            <span
              role="button"
              className={`home-nav-link ${location.pathname === "/tc-register" ? "home-nav-active" : ""}`}
              onClick={handleClick4}
            >
             {agentVendorType &&
              token &&
              agentVendorType === "Transaction Coordinator" ? (
                <>Dashboard</>
              ) : (
                <>Transaction Coordinator</>
              )}
            </span>
          </NavItem>
          <NavItem className="mobile-nav-item">
            <span
              role="button"
              className={`home-nav-link ${location.pathname === "/agent-register" ? "home-nav-active" : ""}`}
              onClick={handleClick2}
            >
              {agentVendorType &&
              token &&
              (agentVendorType === "Showing Agent" ||
                agentVendorType === "Listing Agent") ? (
                <>Dashboard</>
              ) : (
                <>Agents</>
              )}
            </span>
          </NavItem>
          <NavItem className="mobile-nav-item">
            <Link
              className={`home-nav-link ${location.pathname === "/contact-us" ? "home-nav-active" : ""}`}
              to="/contact-us"
            >
              Contact us
            </Link>
          </NavItem>
          <NavItem className="mobile-nav-item">
            <span
              role="button"
              className={`home-nav-link ${location.pathname === "/user-register" ? "home-nav-active" : ""}`}
              onClick={handleClick}
            >
              {userId && token ? <>Dashboard</> : <>Client Register/Login</>}
            </span>
          </NavItem>
        </Nav>
      </Collapse>
    </Navbar>
  );
}

export default NavbarComponent;
